<template>
  <section class="products" id="products">
    <b-container fluid class="content">
      <b-row>
        <b-col>
          <h2 class="products__title">
            {{ $props.title }}
            <span class="line"></span>
          </h2>
          <p class="products__description">
            {{ $props.description }}
          </p>
          <div v-if="$props.alone === '' || $props.alone === undefined " class="products__options" name="more_products" id="more_products"  >
            <button
                :class="state == 1 ? 'active' : ''"
                v-on:click="changeOption(1)"
            >
              {{$props.subtitle_1}}
            </button>
            <button
                :class="state == 2 ? 'active' : ''"
                v-on:click="changeOption(2)"
                id="quick_services"
            >
              {{$props.subtitle_2}}
            </button>
            <button
                :class="state == 3 ? 'active' : ''"
                v-on:click="changeOption(3)"
            >
              {{$props.subtitle_3}}
            </button>
          </div>
        </b-col>
      </b-row>
      <b-row v-show="state === 1 && ($props.alone=='products' || $props.alone===undefined)">
        <template v-for="(item, index) in $props.products">
          <b-col cols="12" md="6" lg="4" :key="index">
            <div class="products__card">
              <header class="m-3">
                <div class="type">{{$props.subtitle_1}}</div>
              </header>
              <h3 class="align-items-center">
                <img
                    :src="item.icon"
                    alt="icon card"
                />
                {{ item.title }}
              </h3>
              <p>{{ item.description }}</p>
              <div class="price">
                <p>
                  {{from[$props.lang]}} <span>{{ item.price }}
                  </span><span class="currency">{{$props.currency}}</span>
                  / {{ item.period }}
                </p>
                <!--<ButtonComponent  variant="primary" :text="more[$props.lang]" :href="item.link" />-->
              </div>
            </div>
          </b-col>
        </template>
      </b-row>
      <b-row v-show="state == 2 && ($props.alone=='quick' || $props.alone===undefined)">
        <template v-for="(item, index) in $props.services">
          <b-col cols="12" md="6" lg="4" :key="index" >
            <div class="products__card">
              <header>
                <div class="location text-capitalize">
                  {{ item.location }} <b-icon icon="globe"></b-icon>
                </div>
                <div class="type">{{subtitle_2}}</div>
              </header>
              <h3 class="align-items-start">
                <img
                    :src="item.icon"
                    alt="icon card"
                />
                {{ item.title }}
              </h3>
              <p>{{ item.description }}</p>
              <div class="price">
                <p>
                  <span>{{ item.price }}</span> / pago único
                </p>
                <!--<buttonPrimry
                    v-if="item.link"
                    :configButton="configButton2"
                    @funcionBtn="funcioRedirect(item.link)"
                />
                <buttonPrimry v-else :configButton="configButton2_en" />-->
              </div>
            </div>
          </b-col>
        </template>
      </b-row>
      <b-row v-show="state == 3 && ( $props.alone=='services' || $props.alone===undefined)">
        <template v-for="(item, index) in $props.software">
          <b-col cols="12" md="6" lg="4" :key="index">
            <div class="products__card">
              <header class="m-3">
                <div class="type">{{ subtitle_3 }}</div>
              </header>
              <h3>
                <img :src="item.icon" alt="icon card" />
                {{ item.title }}
              </h3>
              <p>
                {{ item.description }}
                <span class="badge badge-secondary">{{ item.limit }}</span>
              </p>
              <div class="price">
                <p>
                  {{ from[$props.lang] }} <span>{{ item.price }} {{currency}}</span> / {{ item.period }}
                </p>
                <!--<buttonPrimry
                    v-if="$props.lang == 'es'"
                    :configButton="configButton3_es"
                    @funcionBtn="funcioRedirect(item.link)"
                />
                <buttonPrimry
                    v-if="$props.lang == 'en'"
                    :configButton="configButton3_en"
                    @funcionBtn="funcioRedirect(item.link)"
                />-->
              </div>
            </div>
          </b-col>
        </template>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import buttonPrimry from '@/packages/ducksites.ui/components/buttons/ButtonBasic'
import ButtonComponent from '@/packages/ducksites.ui/components/buttons/ButtonComponent'
export default {
  name: 'CardsProducts',
  components: {
    buttonPrimry,
    ButtonComponent
  },
  props: {
    lang: String,
    currency: String,
    country: String,
    alone: String,
    title: String,
    description: String,
    subtitle_1: String,
    subtitle_2: String,
    subtitle_3: String,
    products:{
      type: Array,
      default: () => []
    },
    services:{
      type: Array,
      default: () => []
    },
    software:{
      type: Array,
      default: () => []
    }
  },
  data: function () {
    return {
      state: 1,
      more: { es: 'Saber m&aacute;s', en: 'Learn more' },
      from: { es:'Desde', en: 'From'},
      /*products: [
        {
          es: {
            icon: 'icon-suppmail.svg',
            title: 'Suppmail',
            description: 'Herramienta más completa para automatizar, gestionar y centralizar solicitudes de clientes (Quejas, soprotes, reclamos, recomendaciones, etc). Atiende a tus usuarios de forma rápida y sencilla.',
            price: { cop: '$1.000.000', usd: '$250', cad: '$300' },
            link: '/products/suppmail/',
            period: 'año',
            show: true
          },
          en: {
            icon: 'icon-suppmail.svg',
            title: 'Suppmail',
            description: 'Smart feedback and complaints system for your small business. Organize, improve and accelerate your helpdesk and servicedesk.',
            price: { cop: '$1.000.000', usd: '$250', cad: '$300' },
            link: '/products/suppmail/',
            period: 'year',
            show: true
          }
        },
        {
          es: {
            icon: 'icon-wabot.svg',
            title: 'Wabot',
            description: 'Brinda atención oportuna, eficiente y óptima para clientes y usuarios. Automatizamos la atención al cliente generando la innovación que tu empresa necesita.',
            price: { cop: '$500.000', usd: '$100', cad: '$100' },
            link: '/products/wabot/',
            period: 'año',
            show: true
          },
          en: {
            icon: 'icon-wabot.svg',
            title: 'Wabot',
            description: 'Brinda atención oportuna, eficiente y óptima para clientes y usuarios. Automatizamos la atención al cliente generando la innovación que tu empresa necesita.',
            price: { cop: '$500.000', usd: '$100', cad: '$100' },
            link: '/products/wabot/',
            period: 'year',
            show: false
          }
        },
        {
          es: {
            icon: 'icon-grumpyturtle.svg',
            title: 'Grumpyturtle',
            description: 'Planea proyectos, organiza a tu equipo y cumple tus metas. La mejor opción para startups, utilizamos scrum para integrar equipos y aumentar su productividad.',
            price: { cop: '$500.000', usd: '$100', cad: '$100' },
            link: '/products/grumpyturtle/',
            period: 'año',
            show: true
          },
          en: {
            icon: 'icon-grumpyturtle.svg',
            title: 'Grumpyturtle',
            description: 'Planea proyectos, organiza a tu equipo y cumple tus metas. La mejor opción para startups, utilizamos scrum para integrar equipos y aumentar su productividad.',
            price: { cop: '$500.000', usd: '$100', cad: '$100' },
            link: '/products/grumpyturtle/',
            period: 'year',
            show: false
          }
        },
        {
          es: {
            icon: 'icon-proposals.svg',
            title: 'Proposals',
            description: 'Acelera la gestión de cotizaciones en tu empresa de servicios, ideal para consultores, asesores, diseñadores, abogados y cualquier otro contratista de servicios.',
            price: { cop: '$500.000', usd: '$125', cad: '$150' },
            link: '/products/grumpyturtle/',
            period: 'año',
            show: true
          },
          en: {
            icon: 'icon-proposals.svg',
            title: 'Proposals',
            description: ' Impulse your sales with a quotation system, plans, customers and opened alerts and more. Cool and clean quotations to sell your services.',
            price: { cop: '$500.000', usd: '$125', cad: '$150' },
            link: '/products/grumpyturtle/',
            period: 'year',
            show: true
          }
        },
        {
          es: {
            icon: 'icon-provedur.svg',
            title: 'Provedur',
            description:
                'Dinamiza tu gestión de compras y contratación de proveedores con una solución innovadora y totalmente en la nube.\n',
            price: { cop: '$1.000.000', usd: '$250', cad: '$300' },
            link: '/products/provedur',
            period: 'año',
            show: true
          },
          en: {
            icon: 'icon-provedur.svg',
            title: 'Provedur',
            description:
                'Dinamiza tu gestión de compras y contratación de proveedores con una solución innovadora y totalmente en la nube.\n',
            price: { cop: '$1.000.000', usd: '$250', cad: '$300' },
            link: '/products/provedur',
            period: 'year',
            show: false
          }
        },
        {
          es: {
            icon: 'icon-transpur.svg',
            title: 'Transpur',
            description: 'Simplificando la gestión en empresas de transporte. Sistema integral para la gestión en empresas de transporte de personas y carga.\n',
            price: { cop: '$3.000.000', usd: '$800', cad: '$900' },
            link: '/products/transpur',
            period: 'año',
            show: true
          },
          en: {
            icon: 'icon-transpur.svg',
            title: 'Transpur',
            description: 'Simplificando la gestión en empresas de transporte. Sistema integral para la gestión en empresas de transporte de personas y carga.\n',
            price: { cop: '$3.000.000', usd: '$800', cad: '$900' },
            link: '/products/transpur',
            period: 'year',
            show: false
          }
        },
        {
          es: {
            icon: "icon-gogoals.svg",
            title: "Gogoals",
            description: "Email marketing para crecer. Transforma tu negocio con email marketing automatizad para mostrar tus productos y servicios.",
            price: { cop: '$1.000.000', usd: '$250', cad: '$300' },
            link: "https://systemico.net/products/gogoals",
            period: 'year',
            show: true
          },
          en: {
            icon: "icon-gogoals.svg",
            title: "Gogoals",
            description: "Email marketing to growth. Transform your business with automate email marketing and show your products and services.",
            price: { cop: '$1.000.000', usd: '$250', cad: '$300' },
            link: "https://systemico.net/products/gogoals",
            period: 'year',
            show: true
          }

        }*/
        /** {
          icon: "icon-focusmeet.svg",
          title: "Focusmeet",
          description:
            "Te acompañamos en los procesos de planeación, desarrollo de la reunión y seguimiento de compromisos, buscando aumentar la productividad y el cumplimiento de tus metas.Te acompañamos en los procesos de planeación, desarrollo de la reunión y seguimiento de compromisos, buscando aumentar la productividad y el cumplimiento de tus metas.",
          price: "$10 USD",
          link: "/products/focusmeet/",
        },**/
        /** {
          icon: "icon-chatter.svg",
          title: "Chatter",
          description:
            "Asegura la comunicación de tu equipo en tiempo real e integra las atenciones directas a clientes que visitan tus canales digitales.",
          price: "$10 USD",
          link: "",
        },**/
        /** {
          icon: "icon-ducksite.svg",
          title: "Ducksites",
          description:
            "Genera sitios web de manera sencilla para promover el crecimiento de tu marca y producto.",
          price: "$10 USD",
          link: "",
        },**/

        /** {
          icon: "icon-penguin.svg",
          title: "Penguin Strategy",
          description:
            "Te ayudamos a gestionar todo el proceso comercial de las pymes o startups enfocándonos en el resultado para mejorar su impacto y rentabilidad.",
          price: "$10 USD",
          link: "",
        },
         {
          icon: "icon-pugobox.svg",
          title: "Pugobox",
          description:
            "Ayuda a las empresas a asegurar su información y a establecer buenas practicas. Gestionamos, clasificamos y respaldamos todos tus archivos.",
          price: "$10 USD",
          link: "",
        },**/
      /*],*/
      /*services: [
        {
          es: {
            icon: 'icon-service-2.svg',
            title: 'Login con Google - Flask',
            description: 'Simplifica el proceso de autenticación de tus clientes con un botón de Google para que los usuarios accedan con su cuenta de Gmail sin tener que memorizar una nueva clave.',
            price: { cop: '$1.000.000', usd: '$250', cad: '$300' },
            link: '/services/?id=7',
            location: 'global',
            show: true
          },
          en: {
            icon: 'icon-service-2.svg',
            title: 'Login con Google - Flask',
            description: 'Login authentication module to use on flask applications to simplify the login process for each customer.',
            price: { cop: '$1.000.000', usd: '$250', cad: '$300' },
            link: '/services/?id=7',
            location: 'global',
            show: true
          }
        },
        {
          es: {
            location: 'global',
            icon: 'icon-service-2.svg',
            title: 'Habilitación del Login con Outlook',
            description:
                'Simplifica el proceso de autenticación de tus clientes con un botón de Outlook para que los usuarios accedan con su cuenta de Gmail sin tener que memorizar una nueva clave.',
            price: { cop: '$1.000.000', usd: '$250', cad: '$300' },
            link: '/services/?id=8',
            show: true
          },
          en: {
            icon: 'icon-service-2.svg',
            title: 'Habilitación del Login con Outlook',
            description:
                'Simplifica el proceso de autenticación de tus clientes con un botón de Outlook para que los usuarios accedan con su cuenta de Gmail sin tener que memorizar una nueva clave.',
            price: { cop: '$1.000.000', usd: '$250', cad: '$300' },
            link: '/services/?id=8',
            location: 'global',
            show: true
          }
        },
        {
          es: {
            location: 'global',
            icon: 'icon-service-2.svg',
            title: 'Habilitación del Login con Linkedin',
            description: 'Simplifica el proceso de autenticación de tus clientes con un botón de Linkedin para que los usuarios accedan con su cuenta de Gmail sin tener que memorizar una nueva clave.',
            price: { cop: '$1.000.000', usd: '$250', cad: '$300' },
            link: '/services/?id=9',
            show: true
          },
          en: {
            location: 'global',
            icon: 'icon-service-2.svg',
            title: 'Habilitación del Login con Linkedin',
            description: 'Simplifica el proceso de autenticación de tus clientes con un botón de Linkedin para que los usuarios accedan con su cuenta de Gmail sin tener que memorizar una nueva clave.',
            price: { cop: '$1.000.000', usd: '$250', cad: '$300' },
            link: '/services/?id=9',
            location: 'global',
            show: true
          }
        },
        {
          es: {
            location: 'global',
            icon: 'icon-service-3.svg',
            title: 'Habilitar un módulo de notificaciones (SMS, EMAIL y PUSH)',
            description: 'Gestión automatizada de notificaciones SMS, EMAIL y PUSH para su aplicación.',
            price: { cop: '$1.000.000', usd: '$250', cad: '$300' },
            link: '/services/?id=10',
            show: true
          },
          en: {
            location: 'global',
            icon: 'icon-service-3.svg',
            title: 'Habilitar un módulo de notificaciones (SMS, EMAIL y PUSH)',
            description: 'Gestión automatizada de notificaciones SMS, EMAIL y PUSH para su aplicación.',
            price: { cop: '$1.000.000', usd: '$250', cad: '$300' },
            link: '/services/?id=10',
            show: true
          }
        },
        {
          es: {
            location: 'global',
            icon: 'icon-service-6.svg',
            title: 'Habilitación del monitor de las aplicaciones',
            description: 'Monitoreo de LOGS y ACCESOS para identificar inconvenientes o fallas potenciales.',
            price: { cop: '$1.000.000', usd: '$250', cad: '$300' },
            link: '/services/?id=11',
            show: true
          },
          en: {
            location: 'global',
            icon: 'icon-service-6.svg',
            title: 'Habilitación del monitor de las aplicaciones',
            description: 'Monitoreo de LOGS y ACCESOS para identificar inconvenientes o fallas potenciales.',
            price: { cop: '$1.000.000', usd: '$250', cad: '$300' },
            link: '/services/?id=11',
            show: true
          }
        },
        {
          es: {
            location: 'colombia',
            icon: 'icon-service-5.svg',
            title: 'Emisión de documentos soporte',
            description: 'Servicio para automatizar la remisión de los documentos soporte a la DIAN a partir del proveedor tecnológico Carvajal ó Factura 1.',
            price: { cop: '$1.000.000', usd: '$250', cad: '$300' },
            link: '/services/?id=12',
            show: true
          },
          en: {
            location: 'colombia',
            icon: 'icon-service-5.svg',
            title: 'Emisión de documentos soporte',
            description: 'Servicio para automatizar la remisión de los documentos soporte a la DIAN a partir del proveedor tecnológico Carvajal ó Factura 1.',
            price: { cop: '$1.000.000', usd: '$250', cad: '$300' },
            link: '/services/?id=12',
            show: true
          }
        },
        {
          es: {
            location: 'colombia',
            icon: 'icon-service-5.svg',
            title: 'Inbox de Facturación Electrónica',
            description: 'Servicio para automatizar las facturas emitidas por proveedores y registro al software contable o ERP. 1. Carvajal a Seven. 2. Factura 1 a Seven.',
            price: { cop: '$1.000.000', usd: '$250', cad: '$300' },
            link: '/services/?id=13',
            show: true
          },
          en: {
            location: 'colombia',
            icon: 'icon-service-5.svg',
            title: 'Inbox de Facturación Electrónica',
            description: 'Servicio para automatizar las facturas emitidas por proveedores y registro al software contable o ERP. 1. Carvajal a Seven. 2. Factura 1 a Seven.',
            price: { cop: '$1.000.000', usd: '$250', cad: '$300' },
            link: '/services/?id=13',
            show: true
          }
        }
      ],*/
      configButton1_es: { text: 'Probar', class: 'button--secundary' },
      configButton2_en: { text: 'Try it', class: 'button--secundary' },
      configButton2: { text: { es: 'Comprar', en: 'Buy' }, class: 'button--secundary' },
      configButton3_es: { text: 'Saber más', class: 'button--secundary' },
      configButton3_en: { text: 'More', class: 'button--secundary' },
      /*software: [
        {
          es:{
            icon: 'icon-requirements.svg',
            title: 'Desarrollo API REST',
            description:
                'Desarrollamos API REST con Python, PHP y Java para simplificar la integraciones de servicios e incluir opciones de datos abiertos.',
            price: { cop: '$1.500.000', usd: '$400', cad: '$500' },
            link: '/services/microservices',
            limit: '10h',
            period: 'mes',
            show: true
          },
          en: {
            icon: 'icon-requirements.svg',
            title: 'API REST Development',
            description:
                'Develop an API REST Microservice with Python, PHP or Java. Use OpenAPI to integrate diferent applications, customers and services managing the business rules from an unique place.',
            price: { cop: '$1.500.000', usd: '$400', cad: '$500' },
            link: '/services/microservices',
            limit: '10h',
            period: 'month',
            show: true
          }
        }
        // { title: '', description: '', price: '' }
      ],*/
      configButton4: { text: 'Próximamente', class: 'button--gray' }
    }
  },
  methods: {
    changeOption: function (option) {
      this.state = option
    },
    funcioRedirect: function (link) {
      window.location = link
    }
  },
  watch:{
    products: function(){
      console.log('products', this.products)
    }
  }
}
</script>
<style lang="scss" scoped>
.content{
  max-width:1280px;
}
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Mulish:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Quicksand:wght@300;400;500;600;700&display=swap');
$font-quicksand: 'Quicksand', sans-serif;
$font-mulish: 'Mulish', sans-serif;
$color-white: #FFFFFF;
$color-gray: #E9ECF4;
$color-black: #171E44;
$color-black--light: #4B5771;
$color-blue: #006DF0;
$color-blue--dark: #171E44;
$color-celeste: #009DFF;
$color-orange: #FF8028;
// breakpoints
$breakpoint-tablet: 768px;
$breakpoint-normal: 992px;
.products {
  /**background-image: url(https://cdn.systemico.net/systemico/images/productivity/banner-3.jpg);**/
  background-size: 100vw 100vh;
  background-position: top;
  background-repeat: no-repeat;
  background-attachment: fixed;
  position: relative;
  padding-top:2rem;
  background:#006DF0;

  &--background-1 {
    background-image: url(https://cdn.systemico.net/systemico/images/productivity/banner-2.jpg);
  }

  &--background-2 {
    background-image: url(https://cdn.systemico.net/systemico/images/productivity/banner-3.jpg);
  }

  &__background {
    width: 100%;
    height: 100%;
    background-color: #006DF0;
    opacity: 0.6;
    backdrop-filter: blur(50px);
    position: absolute;
    top: 0;
    left: 0;
  }

  &__title {
    margin: 0 0 0.8rem;
    font-size: 2.2rem;
    font-weight: 500;
    color: $color-white;
    text-align: center;
    line-height: 2.4rem;

    .line {
      width: 0.5rem;
      height: 2rem;
      border-radius: 0.4rem;
      background-color: $color-orange;
      display: inline-block;
      transform: rotate(90deg);
      position: relative;
      top: 0.8rem;
      right: -0.5rem;
    }
  }

  &__description {
    margin: 0 0 1rem;
    font-size: 1.5rem;
    font-weight: normal;
    color: $color-white;
    text-align: center;
  }

  &__options {
    button {
      &.active {
        background-color: $color-orange;
      }

      width: 100%;
      height: 4rem;
      margin: 0 0 3rem;
      border: 0;
      border-radius: 5rem;
      background-color: #7D8AA7;
      font-family: $font-mulish;
      font-size: 1.3rem;
      font-weight: normal;
      color: $color-white;
      display: flex;
      align-items: center;
      justify-content: center;

      &:hover {
        background-color: $color-orange;
      }
    }
  }

  &__card {
    width: 100%;
    height: calc(100% - 3rem);
    margin: 0 0 3rem;
    padding: 0.5rem;
    border: 0.3rem solid transparent;
    border-radius: 0px 20px;
    background-color: $color-white;
    box-shadow: 0px 3px 10px #4D576F26;
    position: relative;
    transition: all 0.3s;

    &:hover {
      border: 0.3rem solid $color-orange;
    }

    &--green {
      background-color: #EBFFE0;
    }

    &--dark {
      background-color: $color-black;

      & > h3, & > p, .price p {
        color: $color-white!important;
      }
    }

    header {
      margin: 0 0 1rem;
      display: flex;
      align-items: center;
    }

    .location {
      width: max-content;
      padding: 0;
      font-family: $font-mulish;
      font-size: 1.2rem;
      font-weight: 500;
      color: #171E44;
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        margin: 0 0 0 1rem;
        font-size: 1.5rem;
      }
    }

    .type {
      width: max-content;
      margin: 0 0 0 auto;
      padding: 0 1rem;
      border: 0.1rem solid #7D8AA7;
      border-radius: 5rem;
      background: transparent;
      font-size: 1rem;
      font-weight: 500;
      color: #7D8AA7;
      display: flex;
      align-items: self-end;
      justify-content: center;
    }

    & > h3 {
      margin: -45px 0 1rem;
      font-size: 1.2rem;
      font-weight: 500;
      color: $color-black;
      text-align: left;
      display: flex;

      img {
        max-width: 2rem;
        margin: 0 1rem 0 0;
      }
    }

    & > p {
      min-height: 6.4rem;
      margin: 0 0 1rem;
      font-size: 1rem;
      font-weight: normal;
      color: $color-black;
      text-align: left;
      -webkit-line-clamp: 4;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      white-space: normal;
      overflow: hidden;
    }

    .price {
      display: flex;
      align-items: center;
      justify-content: space-between;

      p {
        margin: 0;
        font-size: 0.8rem;
        font-weight: normal;
        color: $color-black;

        span {
          font-size: 1.5rem;
          color: #006DF0;
        }
        .currency{
          font-size:0.8em;
          color:#fefefe;
          background: $color-celeste;
          padding:2px;
          border-radius:0.2em;
          text-transform:uppercase;
        }
      }
    }
  }

  // responsive para dispositivos de tablets en adelante
  @media (min-width: 768px) {
    &__options {
      display: flex;
      align-items: center;
      justify-content: center;
      button {
        max-width: 15rem;
        height: auto;
        margin: 0 1rem 1.5rem;
      }
    }
  }
}
</style>
